import { render, staticRenderFns } from "./CompaniesServicesTable.vue?vue&type=template&id=36d2a8b3&scoped=true&"
import script from "./CompaniesServicesTable.vue?vue&type=script&lang=ts&"
export * from "./CompaniesServicesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2a8b3",
  null
  
)

export default component.exports